import "intl-tel-input/build/js/intlTelInput";
export default function intlTel($el, opts) {
	let hiddenInput = ''
	const elName = $el.attr('name')
	if(opts.bizFormAddHiddenInput) {
		hiddenInput = elName + 'Full'
	}

	$el.intlTelInput({
		initialCountry: 'au',
		preferredCountries: ["au"],
		autoInsertDialcode: true,
		customPlaceholder: function (
			selectedCountryPlaceholder,
			_selectedCountryData
		) {
			return "e.g. " + selectedCountryPlaceholder;
		},
		utilsScript: "/Scripts/intlTelUtils.js",
		hiddenInput,
		...opts,
	});

}



// WEBPACK FOOTER //
// ./src/_js/modules/intlTel.js